import { ReactNode } from 'react';
import { componentWithRef } from '@robocorp/components';
import { styled } from '@robocorp/theme';

import { File } from './components/File';

type Props = {
  children?: ReactNode;
};

const compoundComponents = {
  File,
};

const Container = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.$4};
`;

/**
 * Component to display a list of files with actions defined for each
 *
 * @example
 * <FileList>
 *   <Filelist.File onClick={onClick} fileName="Foo.bar" fileSize="12Kb">
 *      <Button icon={IconTrash} onClick={onRemove} variant="ghost" aria-label="delete" />
 *   <Filelist.File>
 * </FileList>
 */
export const FileList = componentWithRef<Props, HTMLUListElement, typeof compoundComponents>(
  ({ children }, forwardedRef) => {
    return <Container ref={forwardedRef}>{children}</Container>;
  },
  compoundComponents,
);
